'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var iconStyles = require('../iconStyles.js');
var SvgIcon = require('../../node_modules/@material-ui/core/esm/SvgIcon/SvgIcon.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var InstapayAppIcon = function InstapayAppIcon(props) {
  return React__default["default"].createElement(SvgIcon["default"], _objectSpread({}, props, {
    viewBox: "0 0 500 500",
    version: "1.1"
  }), React__default["default"].createElement("g", {
    id: "Instapay",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React__default["default"].createElement("rect", {
    id: "Rectangle-4",
    fill: "#1E88E5",
    x: "0",
    y: "102",
    width: "450",
    height: "297",
    rx: "40"
  }), React__default["default"].createElement("path", {
    d: "M40,102 L410,102 C432.09139,102 450,119.90861 450,142 L450,359 C450,381.09139 432.09139,399 410,399",
    id: "Rectangle-4-Copy",
    fill: "#1976D2"
  }), React__default["default"].createElement("rect", {
    id: "Rectangle-6",
    fill: "#FFFFFF",
    x: "30",
    y: "207",
    width: "90",
    height: "67",
    rx: "5"
  }), React__default["default"].createElement("rect", {
    id: "Rectangle-6",
    fill: "#FFFFFF",
    x: "30",
    y: "304",
    width: "90",
    height: "25"
  }), React__default["default"].createElement("rect", {
    id: "Rectangle-6",
    fill: "#FFFFFF",
    x: "130",
    y: "304",
    width: "90",
    height: "25"
  }), React__default["default"].createElement("rect", {
    id: "Rectangle-6",
    fill: "#FFFFFF",
    x: "230",
    y: "304",
    width: "90",
    height: "25"
  }), React__default["default"].createElement("polygon", {
    id: "Rectangle-6-Copy",
    fill: "#EEEEEE",
    points: "292 304 320 304 320 327"
  }), React__default["default"].createElement("rect", {
    id: "Rectangle-6",
    fill: "#EEEEEE",
    x: "330",
    y: "304",
    width: "90",
    height: "25"
  }), React__default["default"].createElement("circle", {
    id: "Oval-7",
    fill: "#00314a",
    cx: "399",
    cy: "353",
    r: "101"
  }), React__default["default"].createElement("polygon", {
    id: "Shape",
    fill: "#00C96B",
    points: "419.788387 278 357 365.211613 395.365162 365.211613 376.174302 428 440.701292 340.788387 402.33613 340.788387"
  })));
};

var InstapayAppIcon$1 = iconStyles()(InstapayAppIcon);

module.exports = InstapayAppIcon$1;
